export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  DADOS_CRIPTOGRAFAR: {
    algoritmo : "aes256",
    segredo : "OZt5fUh3ol6o6WrU",
    tipo : "hex"
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js